import { Checkbox, FormControlLabel } from '@material-ui/core';
import { CheckboxProps } from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import React, { Component } from 'react';

interface TnCheckboxProps extends CheckboxProps {
  label: string;
  onChange: (...args: any[]) => any;
  classes: any;
  value?: boolean;
}

class TnCheckbox extends Component<TnCheckboxProps, any> {
  constructor(props: TnCheckboxProps) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange() {
    if (this.props.value) {
      this.props.onChange(false);
    } else {
      this.props.onChange(true);
    }
  }
  render():
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    | string
    | number
    | {}
    | React.ReactNodeArray
    | React.ReactPortal
    | boolean
    | null
    | undefined {
    let { value, label, classes } = this.props;
    return (
      <FormControlLabel
        classes={{ root: classes.root, label: classes.label }}
        data-testid={label}
        control={
          <Checkbox
            disableRipple={true}
            style={{ color: 'black' }}
            classes={{ root: classes.checkBoxRoot }}
            icon={
              <CheckBoxOutlineBlankIcon
                /*classes={{iconButton: classes.iconButton}}*/ className={classes.checkboxBlank}
              />
            }
            className={classes.checkboxDimensions}
            checkedIcon={
              <CheckBoxIcon className={`${this.props.disabled ? classes.checkBoxDisable : classes.checkedBox}`} />
            }
            checked={value}
          />
        }
        label={label}
        onChange={(event, checked) => this.props.onChange(checked)}
      />
    );
  }
}

export default withStyles((theme: any) => ({
  root: {
    marginRight: 0,
  },
  checkBoxRoot: {
    '&:hover': {
      backgroundColor: 'unset !important',
    },
  },
  label: {
    color: '#1C1E20',
    fontSize: '14px',
    fontFamily: 'Avenir !important',
    alignmentItems: 'center',
  },
  checkboxDimensions: {
    width: 16,
    height: 16,
  },
  checkboxBlank: {
    fontSize: 24,
    color: '#526173',
    borderRadius: '2px',
  },

  checkedBox: {
    fontSize: 24,
    color: theme.palette.primary.main,
    borderRadius: '2px',
  },
  checkBoxDisable: {
    fontSize: 24,
    color: '#606060',
    borderRadius: '2px',
  },
}))(TnCheckbox);
